import React, { useState, useEffect } from 'react';
import './index.css';
import consts from "../../config/const";
import ReactPlayer from 'react-player'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebook, faInstagram, faLinkedinIn, faTwitter, faYoutube } from "@fortawesome/free-brands-svg-icons"
import Timer from 'react-compound-timer'
const HomeScreen = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [teamLists, setTeamLists] = useState([]);
  const [mobile, setMobile] = useState("");
  useEffect(() => {
    fetch(consts.API_URL + "testimonials", {
      method: 'GET', headers: consts.BASE_HEADER,
    }).then((response) => response.json()).then((responseJson) => {
      setTestimonials(responseJson.data);
      setLoading(false)
    }).catch((error) => { console.error(error); });
    _getmatchs(selectedIndex);
  }, [])
  const _getmatchs = (index) => {
    console.log("0000")
    fetch(consts.API_URL + "game-lists/UPCOMING/" + index + "?limit=6", {
      method: 'GET', headers: consts.API_HEADER,
    }).then((response) => response.json()).then((responseJson) => {
      setTeamLists(responseJson.data);
    }).catch((error) => {
      console.error(error);
    });
  };

  const goProfilePage = (match) => {
    window.open(consts.WEB_URL + 'leagues/?type=' + match, "_blank");
  }

  const goDeatilPage = (slug) => {
    window.open(consts.WEB_PAGES_URL + slug, "_blank");
  };

  const namePrint = (name) => {
    if (name.length > 10) {
      return name.slice(0, 6) + "....";
    } else {
      return name.slice(0, 6);
    }
  }
  const sendLink = () => {
    fetch(consts.API_URL + "send-link", {
      method: 'POST', headers: consts.API_HEADER,
      body: JSON.stringify({ mobile }),
    }).then((response) => response.json()).then((json) => {
      setMobile("")
      alert('Please find link on your mobile.');
    }).catch((error) => {
      console.error(error);
    });
  }
  const scrollTo = (view) => {
    const section = document.querySelector('#' + view);
    section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div>
      <div className='topContainer' id='topContainer'>
        <div className='topNovContainer'>
          <div className='logoTop'>
          </div>
          <div className='navTop'>
            <a className='navTopMenu' onClick={() => { scrollTo("topContainer") }}>Home</a>
            <a className='navTopMenu' onClick={() => { scrollTo("Howtoplay") }}>How to Play</a>
            <a className='navTopMenu' onClick={() => { scrollTo("downloadDiv") }}>Download</a>
            <a className='navTopMenu' onClick={() => { scrollTo("headingTestimonial") }}>Testimonials</a>
            <a className='navTopMenu' onClick={() => { goDeatilPage("contact-us") }}>Contact Us</a>
          </div>
        </div>
        <div className='homeTop'>
          <div className='platTop'>
            <p className='heading'>PLAY FANTASY CRICKET</p>
            <p className='headingTop'>{'SHOW YOUR SKILLS '}</p>
            <p className='headingTop'>{'WIN CASH DAILY !'}</p>
            <div >
              <button className='buttonMoreStyleTop' onClick={() => goProfilePage(0)} >Play</button>
            </div>
          </div>
          <div className='platTopRight'>
          </div>
        </div>
      </div>
      <div className='homeTopJoin'>
        <div className='sendLink'>
          <p className='downloadpDirectly'>Get the download link on your phone</p>
          <div className='downloadDirectly'>
            <input
              keyboardType="number"
              className='downloadInput'
              placeholder='Enter mobile no'
              value={mobile}
              onChange={(e) => { setMobile(e.target.value) }}
            />
            <button className='buttonSendLink' onClick={() => sendLink()} >SEND LINK</button>
          </div>
        </div>
        <div className='hero'>
          <p className='downloadpDirectly'>Download the Official Sweit Game App directly!</p>
          <div className='downloadDirectlybutton'>
            <p className="android" onClick={() => window.open('http://game.sweitinfotech.com/app/com.sweitinfotech.app.apk')}></p>
            <p className="ios" onClick={() => goDeatilPage("ios")}> </p>
          </div>
        </div>

      </div>
      <div className='upcommingMatch'>
        <div className="upcommingLogo"></div>
        <div className='upcommingDetails'>
          <div >
            <p className='headingUpcommingMatch'>Upcoming Matches</p>

          </div>
          <div className='matchdiv'>
            {isLoading ?
              <div className='moreMatches'><p className='loading'>Loading...</p></div> :
              teamLists.length > 0 ?
                teamLists.map((match, key) => {
                  let t1=new Date(match.india_satrttime)
                  let t2=new Date()
                  var hours = (t1.getTime()-t2.getTime());
                  return (
                    <div key={key} className='matchList'>
                      <div className='matchTourDetails'>
                        <p className='matchTourName'>{match.series.name}</p>
                        <p className='matchTourTime'>
                          <Timer
                            initialTime={hours}
                            lastUnit="h"
                            direction="backward"
                          >
                            {() => (
                              <React.Fragment>
                               <Timer.Days /> DD  
                               &nbsp; <Timer.Hours /> HH  
                               &nbsp; <Timer.Minutes /> MM 
                              </React.Fragment>
                            )}
                          </Timer>
                        </p>
                      </div>
                      <div className='matchDetails'>
                        <img className="icon" src={match.home_team.logoUrl} />
                        <div className='matchListInfo'>
                          <p className='matchName'>{namePrint(match.home_team.shortName) + " vs " + namePrint(match.AwayTeam.shortName)}</p>
                          <p className='format'>{match.cmsMatchType}</p>
                        </div>
                        <img className="icon" src={match.AwayTeam.logoUrl} />
                      </div>
                    </div >
                  );

                })
                :
                <div className='moreMatches'><p className='loading'>Coming Soon</p></div>

            }

          </div>
          <div className='moreButtonSendLink'>
            <button className='buttonSendLink' onClick={() => goProfilePage(selectedIndex)} >More Matches</button>
          </div>
        </div>
      </div>
      <div id='Howtoplay'>
        <p className='headingHowToPlay'>How to play</p>
      </div>
      <div className='topHowToPlay'>

        <div className='divTopHowToPlay'>
          <div className='divTopDiv'>
            <p className='howPlayLogo img-0' ></p>
            <p className='playTopTitle'>Select your favourite sports</p>
            <p className='descriptionTop'>Choose according to your preference from the upcoming matches.</p>
          </div>
        </div>

        <div className='divTopHowToPlay'>
          <div className='divTopDiv'>
            <p className='howPlayLogo img-1'></p>
            <p className='playTopTitle'>Create your winning team</p>
            <p className='descriptionTop'>Utilize your skills of sports to choose and create your team and win.</p>
          </div>
        </div>
        <div className='divTopHowToPlay'>
          <div className='divTopDiv'>
            <p className='howPlayLogo img-2'></p>
            <p className='playTopTitle'>Participate in the league of champions</p>
            <p className='descriptionTop'>Enter into the league with your friends and prove your sports skills.</p>
          </div>
        </div>
        <div className='divTopHowToPlay'>
          <div className='divTopDiv'>
            <p className='howPlayLogo  img-3'></p>
            <p className='playTopTitle'>Hit the Jackpot and Win money</p>
            <p className='descriptionTop'>Get ready to earn handsome amount of money</p>
          </div>
        </div>
      </div>
      <div className='howToPlay'>
        <p className='headingTestimonial'>Play Game</p>
        <div className='howPlayContainer'>

          <div className='leftHowToPlay'>
            <ReactPlayer url='https://www.youtube.com/watch?v=wBY2Sb8bbMs' controls={true} playing={false} width={"90%"} />
          </div>
          <div className='rightHowToPlay'>
            <button className='buttonMoreStyleTop' onClick={() => goProfilePage(0)}>PLAY NOW</button>
          </div>
        </div>
      </div>
      <div className='downloadDiv' id="downloadDiv">
        <div className='download-text'>
          <p className='headingDownload'>It's perfect time to join </p>
          <p className='headingTopDownload'>{'Download App Now'}</p>
          <div className='downloadbutton'>
            <p className="android" onClick={() => window.open('http://game.sweitinfotech.com/app/com.sweitinfotech.app.apk')}></p>
            <p className="ios" onClick={() => goDeatilPage("ios")}> </p>
          </div>
        </div>
        <div className='downloadImage'>
        </div>

      </div>
      <div className='follower' id="headingTestimonial">
        <p className='headingTestimonial'>Testimonials</p>
        <p className='headingdiv'>See what our Sweit Game squad have to say.</p>
        <Carousel infiniteLoop={true} interval={2000} autoPlay={true}>
          {testimonials.map((item, key) => {
            return (
              <div key={key} className="each-slide">
                <p className={'officeAddress'}>
                  <img rounded src={consts.API_BLOGS_URL + item.pics} /></p>
                <p className='name'>{item.name}</p>
                <p className='name'>{item.text}</p>
              </div>
            )
          })}

        </Carousel>
      </div>
      <div className='delimiter'>
        <div className='footer'>
          <div className='linkDelimiter'>
            <p className='linkHomeHeading'>SWEIT GAME</p>
            <div className='socialbutton'>
              <FontAwesomeIcon onClick={() => window.open('https://www.facebook.com', "_blank")} icon={faFacebook} style={{ margin: 5, fontSize: 24, cursor: "pointer" }} />
              <FontAwesomeIcon onClick={() => window.open('https://twitter.com/', "_blank")} icon={faTwitter} style={{ margin: 5, fontSize: 24, cursor: "pointer" }} />
              <FontAwesomeIcon onClick={() => window.open('https://www.youtube.com/', "_blank")} icon={faYoutube} style={{ margin: 5, fontSize: 24, cursor: "pointer" }} />
              <FontAwesomeIcon onClick={() => window.open('https://www.instagram.com', "_blank")} icon={faInstagram} style={{ margin: 5, fontSize: 24, cursor: "pointer" }} />
              <FontAwesomeIcon onClick={() => window.open('https://www.linkedin.com', "_blank")} icon={faLinkedinIn} style={{ margin: 5, fontSize: 24, cursor: "pointer" }} />
            </div>
          </div>
          <div className='linkDelimiter'>
            <p className='linkHomeHeading'>Our Links</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("")}>About Us</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("legality")}>Legalities</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("how-to-play")}>How to Play</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("fantasy-point-system")}>Fantasy Point</p>
          </div>
          <div className='linkDelimiterBorder'>
            <p className='linkHomeHeading'>Our Links</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("contact-us")}>Contact Us</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("transactions")}>Transactions</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("career")}>Career</p>
            <p className='linkDelimiterMenu' onClick={() => goDeatilPage("blog")}>Blogs</p>
          </div>


          <div className='linkDelimiter'>
            <p className='linkHomeHeading'>Official Fantasy</p>
            <p className='logoMember offical-fantansy' ></p>
          </div>
          <div className='linkDelimiter'>
            <p className='linkHomeHeading'>Payment System</p>
            <p className='logoMember membership' ></p>
          </div>
        </div>

        <div >
          <p className='delimiterHeadingdiv'>CORPORATE OFFICE</p>
          <p className='officeAddress'>{'Sweit Game Team'}</p>
          <p className='officeAddress'>{'Subsidiary of: 384 Chakdaur, Sidhi MP, 486771'}</p>
          <p className='office-dic'>DISCLAIMER</p>
          <p className='followerp'>Unless otherwise explicitly specified, SWEIT GAME is not affiliated in any way to and claims no association, in any capacity</p>
          <p className='followerp'>whatsoever, with any sports governing bodies and leagues.</p>
        </div>
      </div>
      <div className='privacy'>
        <div className='topNovContainer'>
          <div className='leftPrivacy'>
            <p onClick={() => goDeatilPage("privacy-policy")} className='headingPrivacy'>Privacy Policy</p>
          </div>
          <div className='rightPrivacy'>
            <p onClick={() => goDeatilPage("terms-conditions")} className='headingPrivacy'>Terms & Conditions</p>
          </div>
        </div>

      </div>
    </div>
  );
}
export default HomeScreen;